import { Button, Card, Container, Form } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useNavigate } from "react-router-dom";
import { signupservices } from "../../services/signupservices";

function Signup() {

    const navigate = useNavigate();

    function doSignUp(e) {



        e.preventDefault();
        var form = document.querySelector('#signup-form');

        signupservices.doSignUp(form).then((resp) => {
            console.log(resp.data);
            if (resp === 0) {
                alert(resp.messages);
            }

            navigate("/newAccount");

        });
    }


    return (

        <Container>
            <Card className="mt-3 p-3">
                <Card.Body>
                    <Form onSubmit={e => doSignUp(e)} id="signup-form">

                    <input type='hidden'  name="parentAdminId" value="admin1"/>

                     <Row className="mb-3">
                            <Form.Group as={Col} controlId="formBasicEmail">
                                <Form.Label>Admin Type</Form.Label>
                                <select name="adminType" placeholder="Admin type" className="form-control" >
                                    <option>MASTER</option>
                                    <option>BROKER</option>
                                    <option>CLIENT</option>
                                </select>

                            </Form.Group>

                            <Form.Group as={Col} controlId="formBasicEmail">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control type="text" placeholder="First Name" name="firstName" />
                            </Form.Group>
                            <Form.Group as={Col} controlId="formBasicEmail">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control type="text" placeholder="Last Name" name="lastName" />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formGridEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" name="email" />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" name="password" />
                            </Form.Group>
                            <Form.Group as={Col} controlId="formGridAddress1">
                                <Form.Label>Contact No</Form.Label>
                                <Form.Control placeholder="Contact No" name="contactNo" />
                            </Form.Group>
                        </Row>


                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formBasicEmail">
                                <Form.Label>City</Form.Label>
                                <Form.Control type="text" placeholder="City" name="city" />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridCity">
                                <Form.Label>Client Limit</Form.Label>
                                <input type='number' className='form-control ' name="clientLimit" placeholder="Client Limit" />
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridCity">
                                <Form.Label>Master Limit</Form.Label>
                                <input type='number' className=' form-control ' name="masterLimit" placeholder="Master Limit" />
                            </Form.Group>


                        </Row>
                        
                        <Form.Group className="mb-3" id="formGridCheckbox">
                            <Form.Check type="checkbox" label="Check me out" />
                        </Form.Group>
                        <div className="text-center">
                            <Button variant="primary" type="submit" style={{ width: 100 }}>
                                Submit
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </Container>

    );


}
export default Signup;